<template>
  <div class="lesson" :style="{ paddingTop: headerHeight + 'px' }">
    <SubHeader03 :showUser="true" ref="subHeader" :showNav="true"></SubHeader03>
    <div class="box-line" id="line"></div>
    <div class="lesson-content" :style="{ height: `calc(100vh - ${headerHeight}px)` }">
      <van-list v-model="pageLoading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="news" v-for="item in list" :key="item.id" @click="goDetail(item)">
          <div class="row">
            <div class="info">
              <div class="name">
                {{ item.title }}
              </div>
              <div class="time">
                <span>
                  {{ item.operate_time || item.created_at }}
                </span>
              </div>
            </div>
            <img class="image" :src="item.thumb"></img>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import SubHeader03 from "@/components/SubHeaderJiazhang03";
import axios from "axios";
export default {
  components: {
    SubHeader03,
  },
  data() {
    return {
      pageLoading: false,
      finished: false,
      list: [],
      page: 1,
    };
  },
  mounted() {
    this.getData();
  },
  destroyed() {

  },
  computed: {
    headerHeight() {
      return this.$store.state.headerHeight;
    }
  },
  methods: {
    goDetail(item) {
      console.log(item)
      this.$router.push({
        path: `./publicizedetail/${item.id}`
      })
    },
    onLoad() {
      this.pageLoading = true;
      this.page++;
      axios({
        url: "https://service.hengshui.tuoyupt.com/api/policy/science/sciencelist?page=" + this.page,
      })
        .then(res => {
          return res.data.data;
        }).then(res => {
          this.pageLoading = false;
          this.list.push(...res.data);
          if (this.list.length >= res.total) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        })
    },
    getData() {
      this.pageLoading = true;
      axios({
        url: "https://service.hengshui.tuoyupt.com/api/policy/science/sciencelist?page=" + this.page,
      })
        .then(res => {
          return res.data.data;
        }).then(res => {
          this.pageLoading = false;
          this.list = res.data;
          if (this.list.length >= res.total) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        })
    }
  },
};
</script>
<style lang="scss" scoped>
.lesson {
  min-height: calc(100vh - 230px);
  display: flex;
  align-items: flex-start;
  overflow: hidden;
  background: #f7f8fa;

  .lesson-content {
    flex: 0 1 auto;
    width: 100%;
    display: flex;
    box-sizing: border-box;
  }

  .news {
    height: 140px;
    margin: 26px auto;
    border-bottom: 1px solid #eee;
    width: 90%;

    &:last-child {
      margin-bottom: 0px;
    }

    .row {
      display: flex;
      flex-direction: row;

      .image {
        width: 187px;
        height: 120px;
        border-radius: 20px;
        overflow: hidden;
        object-fit: contain;
      }
    }

    .info {
      flex: 1;

      .name {
        font-size: 28px;
        font-weight: 500;
        color: #262937;
        line-height: 40px;
        max-height: 88px; //定高
        display: block;
        display: -webkit-box; //将对象作为弹性伸缩盒子模型显示，
        -webkit-line-clamp: 2; //设置显示的文本的行数
        -webkit-box-orient: vertical; //设置或检索伸缩盒对象的子元素的排列方式 
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .time {
        font-size: 20px;
        font-weight: 400;
        color: #AEB0BC;
        margin-top: 24px;

        .type {
          margin-left: 40px;
        }
      }
    }

  }


}
</style>
